/* eslint-disable no-unused-vars */
import React, {Component} from "react";
import {InputLabel, withStyles, Select, MenuItem} from "@material-ui/core";
import classNames from 'classnames';
import FormControl from '@material-ui/core/FormControl';
import {API} from "../../../config";
import Util from "../../../yeffect/utils";

const country = API.service('country');

const styles = theme => ({
    input: {
        width: '100%',
    },
    wrapper:{
        paddingLeft:'8px',
        paddingRight:'8px'
    }
});

class CountrySelect extends Component {
    state = {
        active:     this.props.active || 1,
        countries:  false,
        options:    false,
    };

    updateOptions = () => {
        const app = this;

        let options = [];

        if(this.props.categoryValue === 'E'){
            options.push(
                {value: 'S', label: 'S: Common/Ordinary Shares'},
                {value: 'P', label: 'P: Preferred/Preference Shares'},
                {value: 'C', label: 'C: Common/Ordinary Convertible Shares'},
                {value: 'F', label: 'F: Preferred/Preference Convertible Shares'},
                {value: 'L', label: 'L: Limited Partnership Units'},
                {value: 'D', label: 'D: Depository Receipts on Equities'},
                {value: 'Y', label: 'Y: Structured Instruments (Participation)'},
                {value: 'M', label: 'M: Others (Miscellaneous)'},
            )
        }

        if(this.props.categoryValue === 'D'){
            options.push(
                {value: 'B', label: 'B: Bonds'},
                {value: 'C', label: 'C: Convertible Bonds'},
                {value: 'W', label: 'W: Bonds with Warrants'},
                {value: 'T', label: 'T: Medium-Term Notes'},
                {value: 'Y', label: 'Y: Money Market Instruments'},
                {value: 'S', label: 'S: Structured Instruments(Capital Protection)'},
                {value: 'E', label: 'E: Structured Instruments (w/o Capital Protection)'},
                {value: 'G', label: 'G: Mortgage-Backed Securities'},
                {value: 'A', label: 'A: Asset-Backed Securities'},
                {value: 'N', label: 'N: Municipal Bonds'},
                {value: 'D', label: 'D: Depository Receipts on Debt Instruments'},
                {value: 'M', label: 'M: Others(Miscellaneous)'},
            )
        }

        if(this.props.categoryValue === 'C'){
            options.push(
                {value: 'I', label: 'I: Standard (Vanilla) Investment Funds/Mutual Funds'},
                {value: 'H', label: 'H: Hedge Funds'},
                {value: 'B', label: 'B: Real Estate Investment Trusts (REIT)'},
                {value: 'E', label: 'E: Exchange Traded Funds (ETF)'},
                {value: 'S', label: 'S: Pension Funds'},
                {value: 'F', label: 'F: Funds of Funds'},
                {value: 'P', label: 'P: Private Equity Funds'},
                {value: 'M', label: 'M: Others(Miscellaneous)'},
            )
        }

        if(this.props.categoryValue === 'R'){
            options.push(
                {value: 'A', label: 'A: Allotment (Bonus) Rights'},
                {value: 'S', label: 'S: Subscription Rights'},
                {value: 'P', label: 'P: Purchase Rights'},
                {value: 'W', label: 'W: Warrants'},
                {value: 'F', label: 'F: Mini-Future Certificate/Constant Leverage Certificate'},
                {value: 'D', label: 'D: Depository Receipts on Entitlements'},
                {value: 'M', label: 'M: Others(Miscellaneous)'},
            )
        }

        if(this.props.categoryValue === 'O'){
            options.push(
                {value: 'C', label: 'C: Call Options'},
                {value: 'P', label: 'P: Put Options'},
                {value: 'M', label: 'M: Others(Miscellaneous)'},
            )
        }

        if(this.props.categoryValue === 'F'){
            options.push(
                {value: 'F', label: 'F: Financial Futures'},
                {value: 'C', label: 'C: Commodities Futures'},
            )
        }

        if(this.props.categoryValue === 'T'){
            options.push(
                {value: 'C', label: 'C: Currencies'},
                {value: 'T', label: 'T: Commodities'},
                {value: 'R', label: 'R: Interest Rates'},
                {value: 'I', label: 'I: Indices'},
                {value: 'B', label: 'B: Baskets'},
                {value: 'D', label: 'D: Stock Dividends'},
                {value: 'M', label: 'M: Others(Miscellaneous)'},
            )
        }

        if(this.props.categoryValue === 'M'){
            options.push(
                {value: 'C', label: 'C: Combined Instruments'},
                {value: 'M', label: 'M: Other Assets'},
            )
        }

        app.setState({
            options: options
        })
    }

    componentDidMount() {
        this.updateOptions();
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if(this.props.categoryValue !== prevProps.categoryValue){
            this.updateOptions();
        }
    }

    render() {
        const { classes, possibleValues, value, width, onChange, fieldLabel, fieldName, errorFields, categoryValue} = this.props;
        const { active } = this.state;

        return (
            <React.Fragment>
                <div className={classNames(classes.wrapper,width)}>

                    <FormControl className={classNames('w-full')} >
                        <InputLabel shrink={(!Util.isEmpty(value) || value === false)} id={fieldName + '_label'}>{fieldLabel} {(this.props.required === true) ? '*' :''}</InputLabel>
                        <Select
                            labelId={fieldName + '_label'}
                            id={fieldName}
                            value={value}
                            label="Age"
                            name={fieldName}
                            onChange={onChange}
                            error={!(typeof errorFields[fieldName] === "undefined")}
                            helperText={(typeof errorFields[fieldName] !== "undefined") ? errorFields[fieldName] : false}
                            required={this.props.required}
                            >


                            <option value=""> </option>
                            {(this.state.options !== false) &&
                            this.state.options.map(o => {
                                return (
                                    <MenuItem value={o.value}>{o.label}</MenuItem>
                                )

                            })
                            }
                        </Select>
                    </FormControl>

                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(CountrySelect);


// WEBPACK FOOTER //
// ./src/yeffect/formBuilder/components/CFIGroupSelect.js